<!--
     <AlertNotification/>

-->

<template>
  <v-overlay 
    :value="snackbar" 
    :z-index="1000" 
    :opacity="0.2"
  >
    <v-snackbar
      :value="snackbar"
      multi-line
      :timeout="timeout"
      :color="type"
      elevation="0"
      class="qmkey-alert-snackbar w-100"
      content-class="d-block w-100"
      @input="close_alert"
    >
      <v-alert
        :value="snackbar"
        :type="type"
        class="ma-0 w-100  qmkey-alert pr-8 pl-0 mb-1 mt-1"
      >
        <div class="d-block w-100">
          <div class="qmkey-alert-content">

            <!-- ALERT MESSAGE -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:default; overflow: hidden; text-overflow: ellipsis; text-wrap: wrap;"
                >
                  {{ msg }}
                </span>
              </template>
              <span>{{ msg }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-alert>

      <!-- COUNT DOWN -->
      <v-progress-linear
        v-if="timeout > 0 && progression"
        absolute
        bottom
        :value="Math.floor(100 * (currentTime / (timeout - 100)))"
        :color="prog_colors[type]"
      />
      
      <!-- CLOSE BUTTON -->
      <v-btn
        class="qmkey-alert-close-btn"
        icon
        @click="close_alert"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>

      <!-- COPY BUTTON -->
      <v-tooltip
        v-if="type == 'error'"
        top
        :value="isShowTooltip"
        :open-on-click="false"
        :open-on-focus="false"
        :open-on-hover="false"
      >
        <template v-slot:activator="{ attrs }">
          <v-btn
            class="qmkey-alert-copy-btn"
            @click.stop="copyText"
            icon
            v-bind="attrs"
          >
            <v-icon>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.translator('copied') }}</span>
      </v-tooltip>
      
    </v-snackbar>
  </v-overlay>
</template>

<style lang="scss">
  .qmkey-alert-snackbar {
    justify-content: center;
  }
  .qmkey-alert-content {
    display: flex;
    justify-content: center;
  }
  .qmkey-alert .v-alert__content {
    width: 100%;
    display: block;
  }
  .qmkey-alert-copy-btn {
    place-self: center;
    position: absolute !important;
    bottom: 0px;
    right: 0px;
  }
  .qmkey-alert-close-btn {
    position: absolute !important;
    top: 0px;
    right: 0px;
  }
</style>

<script>
 import { mapState } from 'vuex'

 export default {
  name: "AlertNotification",

  data: () => ({
    snackbar: false,
    msg: '',
    timeout: -1,
    type: 'info',

    currentTime: 0,
    progression: true,

    // To change the colors based on the type of alert, undefined is default value
    prog_colors: {info: 'black', success: 'black'},

    interval: null,
    isShowTooltip: false,
  }),

  computed: {
    ...mapState(['alert_message',]),
  },

  mounted() {
    window.addEventListener("keydown",this.keyboard_esc_event);
  },

  beforeDestroy() {
    window.removeEventListener("keydown",this.keyboard_esc_event);
  },

  methods: {
    close_alert() {
      this.snackbar = false;
    },

    keyboard_esc_event(event) {
      //Close alert with esc keyboard
      if (event.key == 'Escape') {
        this.snackbar = false;
      }
    },

    show(alert) {
      this.currentTime= 0;
      this.timeout    = alert.timeout();
      this.msg        = alert.toString();
      this.type       = alert.type();
      this.snackbar   = true;
    },

    copyText() {
      this.show_tooltip();
      navigator.clipboard.writeText(this.alert_message.copy());
    },

    show_tooltip() {
      this.isShowTooltip = true;
      setTimeout(()=>this.isShowTooltip = false, 1000);
    },

    /* PROGRESS LINE */
    syncPbar() {
      //Create a timeout every 100 miliseconds
      this.interval = setInterval(() => {
        this.currentTime += 100;

        //If our current time is larger than the timeout
        if (!this.snackbar || this.timeout <= this.currentTime) {
          clearInterval(this.interval);
          this.currentTime = 0;
        }

      }, 100);
    }
  },

  watch: {
    alert_message() {
      if (this.alert_message) {
        this.show(this.alert_message);
      }
    },
    /* Progress Line */
    snackbar(v) {
      if (v) this.syncPbar();
    }
  }
};
</script>

